<template>
  <div class="container-fluid">
    <!-- Title -->
    <div class="row flex-row justify-content-between">
      <div class="mb-4">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Offering & Contribution Report
        </div>
      </div>
      <div class="c-pointer" v-if="selectedTab === 'summary'">
        <el-dropdown trigger="click" class="w-100">
          <div class="d-flex default-btn text-dark w-100" size="large">
            <span class="mt-1 s-14 text-head" style="color: #0040ff"
              >Export</span
            >
            <div class="mt-0 ml-1">
              <el-icon :size="10" class="el-icon--right primary--text"
                ><ArrowDownBold
              /></el-icon>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(bookType, index) in bookTypeList"
                :key="index"
              >
                <a
                  class="no-decoration text-dark"
                  @click="downloadFile(bookType)"
                >
                  {{ bookType.name }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="row bg-gray-300 justify-content-center py-3 border-radius-8">
      <div class="col-md-11 mr-4 ml-2">
        <div class="row">
          <div class="col-md-6 px-0 d-flex flex-wrap align-items-center">
            <div class="col-md-4 s-14 text-dak fw-400 col-12">Date range</div>
            <div class="col-md-4 col-12 px-0">
              <div class="col-md-12 px-md-0 pb-2 d-flex">
                <!-- <div>
                <label for="icon" class="fw-400 mb-0 text-dak s-14"
                  >Start Date</label
                >
              </div> -->
                <el-date-picker
                  v-model="startDate"
                  type="date"
                  format="DD/MM/YYYY"
                  class="w-100 calendar"
                />
              </div>
            </div>

            <div class="col-md-4 col-12 px-0 mb-3">
              <div class="col-md-12 px-md-0 pt-md-2">
                <!-- <div>
                <label for="icon" class="fw-400 mb-0 text-dak s-14"
                  >End Date</label
                >
              </div> -->
                <el-date-picker
                  v-model="endDate"
                  type="date"
                  format="DD/MM/YYYY"
                  class="w-100 calendar"
                />
              </div>
            </div>
          </div>

          <div class="col-md-3 col-sm-12 pr-md-0">
            <div class="p-field pt-md-2 p-col-12">
              <!-- <div>
                <label for="icon" class="fw-400 mb-0 text-dak s-14"
                  >Select Categories</label
                >
              </div> -->
              <div>
                <SelectAllDropdown
                  :items="Categories"
                  placeHolderText="Select category"
                  @selected-item="setSelectedAgeGroup"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-3 pr-md-0 mt-2 pt-md-2 mt-md-0">
            <!-- <div>
              <label for="" class="fw-400 mb-0 text-dak s-14"
                >Select Member</label
              >
            </div> -->
            <MembersSearch
              @memberdetail="chooseContact"
              :currentMember="selectedContact"
            />
          </div>
        </div>
      </div>
      <div class="col-md-11">
        <div class="row">
          <div
            class="col-md-12 d-flex justify-content-end mt-4"
            @click="generateReport"
          >
            <el-button
              round
              :color="primarycolor"
              :loading="loading"
              size="large"
              class="text-white w-100 report-button c-pointer"
              >Generate Report
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="d-flex justify-content-center mt-5 cursor-pointer">
          <div
            style="background: #e0f2ff"
            class="p-1 d-flex align-items-center border-radius-8"
          >
            <div
              v-for="tab in tabs"
              :key="tab.id"
              style="color: #08162e"
              class="s-12 px-3"
              :class="{ active: selectedTab === tab.id }"
              @click="handleTabClick(tab.id)"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="selectedTab === 'summary'">
      <div class="col-md-12 px-0 d-flex flex-wrap">
        <div class="col-md-6">
          <offeringColumnChart
            domId="chart1"
            title=""
            distance="5"
            subtitle=""
            :titleMargin="10"
            :data="columnChartData.seriesData"
            :series="columnChartData.categories"
            yAxisText="Amount"
          />
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <offeringPieChart
            v-if="selectedTab === 'summary'"
            domId="chart"
            title=""
            :summary="pieChartData"
          />
        </div>
      </div>
      <div class="col-md-12 px-0">
        <OfferingSummary
          :endDate="endDate"
          :startDate="startDate"
          :bookType="bookTypeItem"
          :fileHeaderToExport="fileHeaderToExport"
          :fileToExport="fileToExport"
          :fileName="fileName"
          :offeringStatementData="offeringStatementData"
          @download-complete="handleDownloadComplete"
        />
      </div>
    </div>
    <!-- Accounts Table -->
    <div class="mt-3 row" v-if="selectedTab === 'details'">
      <div
        class="container-fluild table-main remove-styles2 remove-border responsiveness"
      >
        <table
          id="table"
          class="table remove-styles mt-0 table-hover table-header-area"
        >
          <thead class="table-header-ar">
            <tr class="font-weight-bold">
              <th>ACCOUNTS</th>
              <th class="text-right"></th>
              <th class="text-right"></th>
              <th class="text-right">
                <div class="text-dak s-14">{{ formatDate(startDate) }}</div>
                <div class="text-dak s-14">to {{ formatDate(endDate) }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="4" class="table-header-area-main fw-400 s-14">
                <div>Account</div>
              </td>
            </tr>
            <tr v-for="(item, index) in transactions" :key="index">
              <td class="truncate font-weight-medium">
                {{ item.contributionName }}
              </td>
              <td class="truncate font-weight-medium">
                {{ item.eventName }}
              </td>
              <td class="text-left d-flex justify-content-end">
                {{ formatDate(item.date) }}
              </td>
              <td class="text-right">
                {{ item.currency?.symbol || currentUser.currencySymbol }}
                {{ formatAmount(Math.abs(item.amount)) }}
              </td>
            </tr>

            <!-- Total row for Expenses -->
          </tbody>
          <tbody>
            <tr class="table-header-area-main">
              <td class="font-weight-bold">Total</td>
              <td></td>
              <td></td>
              <td class="text-right font-weight-bold">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(totalOffering) }}
              </td>
            </tr>
          </tbody>
          <div class="mt-4"></div>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, inject } from "vue";
import exportService from "../../../services/exportFile/exportservice.js";
import offeringPieChart from "@/components/charts/ReportPieChart.vue";
import offeringColumnChart from "../../../components/charts/ReportColumnChart.vue";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import SelectAllDropdown from "../ReportsDropdown.vue";
// import { Search } from "@element-plus/icons-vue";
import MembersSearch from "../../../components/membership/MembersSearch.vue";
import OfferingSummary from "./OfferingSummary.vue";
import { ElNotification } from "element-plus";
import incomeExpenseHelper from "./Helper/Incomeexpenses-helper.js";
import dateFormatter from "../../../services/dates/dateformatter.js";
// Date & Filters
// const selectedDate = ref(new Date(Date.now()));
const startDate = ref(new Date().setFullYear(new Date().getFullYear() - 1));
const endDate = ref(new Date(Date.now()));
const loading = ref(false);
const primarycolor = inject("primarycolor");
const offeringStatementData = ref({});
const selectedCategories = ref([]);
const incomeStatement = ref([]);
const showReport = ref(false);
const tableData = ref({});
const transactions = ref([]);
const bookTypeItem = ref("");
const offeringPersonID = ref("");
const selectedContact = ref({});
const displayTitle = ref(false);
const chartForIcomeAndExpense = ref([]);
const fileName = ref("Offering & Contribution Report");
const bookTypeList = ref([
  { name: "xlsx" },
  { name: "csv" },
  { name: "txt" },
  { name: "pdf" },
]);
// const selectedFileType = ref({});
const fileHeaderToExport = ref([]);
const fileToExport = ref([]);
const Categories = ref([]);
const store = useStore();
const selectedTab = ref("summary");

const tabs = [
  { id: "summary", label: "Summary" },
  { id: "details", label: "Details" },
];

const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};
const handleDownloadComplete = (success) => {
  if (success) {
    console.log("Export completed successfully");
    ElNotification.success({ message: "Export completed!" });
  } else {
    console.error("Export failed");
    ElNotification.error({ message: "Export failed!" });
  }
};

// const downloadFile = async (item) => {
//   if (item.name === "pdf") {
//     displayTitle.value = true;
//     await nextTick();
//     exportService.downLoadExcel(
//       item.name,
//       document.getElementById("element-to-print"),
//       fileName.value,
//       fileHeaderToExport.value,
//       fileToExport.value
//     );
//   } else {
//     displayTitle.value = false;
//     exportService.downLoadExcel(
//       item.name,
//       document.getElementById("element-to-print"),
//       fileName.value,
//       fileHeaderToExport.value,
//       fileToExport.value
//     );
//   }
// };
const downloadFile = async (item) => {
  bookTypeItem.value = null;
  await nextTick();
  bookTypeItem.value = item.name;
};
const handleTabClick = async (tabId) => {
  selectedTab.value = tabId;

  // Only refresh data when switching to summary tab
  if (tabId === "summary") {
    await getReport();
  }
};
const setSelectedAgeGroup = (payload) => {
  selectedCategories.value = payload;
};

const chooseContact = (payload) => {
  payload.firstName = payload.name;
  selectedContact.value = payload;
  offeringPersonID.value = payload.id;
};

// Sample Data

const currentUser = computed(() => {
  if (store && Object.keys(store.getters.currentUser).length > 0)
    return store.getters.currentUser;
  return "";
});
const getMemberClassification = async () => {
  try {
    axios
      .get("/api/Financials/Contributions/Items")
      .then((res) => {
        Categories.value = res.data;
      })
      .catch((err) => console.log(err));
  } catch (err) {
    console.log(err);
  }
};
getMemberClassification();
const generateReport = async () => {
  loading.value = true;
  if (offeringPersonID.value) {
    let OfferingCategory = selectedCategories.value.map((i) => i.id);
    try {
      const { data } = await axios.get(
        `/api/Reports/financials/getAllContactsAllContributionsReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}&personID=${offeringPersonID.value}`,
        OfferingCategory
      );
      offeringStatementData.value = data;
      transactions.value = data.transactions.filter((t) => t !== null);
      tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
      incomeStatement.value = data.transactions.filter((i) => i !== null);

      if (incomeStatement.value.length > 0) {
        showReport.value = true;
      } else {
        showReport.value = false;
      }

      chartForIcomeAndExpense.value = data;
      loading.value = false;

      /* function to call service and populate table */
      setTimeout(() => {
        fileHeaderToExport.value = exportService.tableHeaderToJson(
          document.getElementsByTagName("th")
        );
        fileToExport.value = exportService.tableToJson(
          document.getElementById("table")
        );
      }, 1000);
      /* End function to call service and populate table */
      loading.value = false;
    } catch (error) {
      console.log(error);
      loading.value = false;
    }
  } else {
    let OfferingCateringId = selectedCategories.value.map((i) => i.id);
    try {
      const { data } = await axios.get(
        `/api/Reports/financials/getAllContactsAllContributionsReport?startDate=${new Date(
          startDate.value
        ).toLocaleDateString("en-US")}&endDate=${new Date(
          endDate.value
        ).toLocaleDateString("en-US")}&categories=${OfferingCateringId.join(
          ","
        )}`
      );
      offeringStatementData.value = data;
      transactions.value = data.transactions.filter((t) => t !== null);
      tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
      incomeStatement.value = data.transactions.filter((i) => i !== null);

      if (incomeStatement.value.length > 0) {
        showReport.value = true;
      } else {
        showReport.value = false;
      }

      chartForIcomeAndExpense.value = data;
      loading.value = false;

      /* function to call service and populate table */
      setTimeout(() => {
        fileHeaderToExport.value = exportService.tableHeaderToJson(
          document.getElementsByTagName("th")
        );
        fileToExport.value = exportService.tableToJson(
          document.getElementById("table")
        );
      }, 1000);
      /* End function to call service and populate table */
      loading.value = false;
    } catch (error) {
      console.log(error);
      loading.value = false;
    }
  }
};

const getReport = async () => {
  try {
    const { data } = await axios.get(
      `/api/Reports/financials/getAllContactsAllContributionsReport?startDate=${new Date(
        startDate.value
      ).toLocaleDateString("en-US")}&endDate=${new Date(
        endDate.value
      ).toLocaleDateString("en-US")}`
    );
    offeringStatementData.value = data;
    transactions.value = data.transactions.filter((t) => t !== null);
    tableData.value = incomeExpenseHelper.formatAccounts(data.transactions);
    incomeStatement.value = data.transactions.filter((i) => i !== null);

    if (incomeStatement.value.length > 0) {
      showReport.value = true;
    } else {
      showReport.value = false;
    }

    chartForIcomeAndExpense.value = data;

    setTimeout(() => {
      fileHeaderToExport.value = exportService.tableHeaderToJson(
        document.getElementsByTagName("th")
      );
      fileToExport.value = exportService.tableToJson(
        document.getElementById("table")
      );
    }, 1000);
    /* End function to call service and populate table */
    loading.value = false;
  } catch (error) {
    console.log(error);
  }
};
getReport();

const pieChartData = computed(() => {
  if (!offeringStatementData.value?.contributionSummary) return [];

  // Find the Income category

  return offeringStatementData.value.contributionSummary.map((account) => ({
    name: account.name,
    value: Math.abs(account.amount),
  }));
});

const columnChartData = computed(() => {
  if (!offeringStatementData.value?.contributionSummary) {
    return {
      series: [],
      categories: [],
    };
  }

  // Format data for Highcharts
  const categories = offeringStatementData.value.contributionSummary.map(
    (item) => item.name
  );
  const seriesData = offeringStatementData.value.contributionSummary.map(
    (item) => ({
      name: item.name,
      data: [item.amount],
    })
  );

  return {
    categories,
    seriesData,
  };
});

// Calculate the grand total for all expenses
const totalOffering = computed(() => {
  return transactions.value.reduce((sum, item) => sum + item.amount, 0);
});
// Format Amount
const formatAmount = (amount) =>
  amount.toLocaleString("en-NG", { minimumFractionDigits: 2 });
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}

.active {
  background: #ffffff;
  color: #08162e;
  font-weight: 700;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* padding: 15px 0; */
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #d4dde4 !important;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
